import { render, staticRenderFns } from "./AppUpdateDialog.vue?vue&type=template&id=4e5bd112&scoped=true"
import script from "./AppUpdateDialog.vue?vue&type=script&lang=js"
export * from "./AppUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./AppUpdateDialog.vue?vue&type=style&index=0&id=4e5bd112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5bd112",
  null
  
)

export default component.exports